import React, { MouseEvent } from "react";
import {
  BaseModal,
  ModalActions,
  ModalContent,
  ModalHeader,
} from "../giselle-modal";
import { FormSize, FormThemeProvider } from "../ecosystems/forms";
import { Button } from "@/components/ui/button";
import styled from "styled-components";

interface DialogProps {
  show: boolean;
  className?: string;
  alert?: boolean;
  dialogClassName?: string;
  title?: React.ReactNode | undefined;
  message?: ((props: { cancel(): void }) => React.ReactNode) | React.ReactNode;
  confirmDisabled?: boolean;
  confirmText?: React.ReactNode;
  cancelText?: React.ReactNode;
  confirmType?: { alert: boolean };
  onConfirm(): void;
  onCancel(event: MouseEvent<HTMLButtonElement>): void;
  maxWidth?: string;
}
export function ConfirmModal(props: DialogProps): JSX.Element {
  const {
    confirmDisabled = false,
    message = "Are you sure?",
    confirmText = "Confirm",
    cancelText = "Cancel",
    confirmType,
  } = props;

  return (
    <BaseModal
      show={props.show}
      onHide={props.onCancel}
      className={`${props.className} ${props.dialogClassName}`}
      maxWidth={props.maxWidth}
    >
      <ModalHeader title={props.title ?? message} onHide={props.onCancel} />
      <ModalContent>
        <ModalContentWrap>
          {props.title &&
            (typeof message === "function"
              ? message({ cancel: props.onCancel })
              : message)}
        </ModalContentWrap>
      </ModalContent>
      <ModalActions variant="space-between">
        <FormThemeProvider size={FormSize.large}>
          <Button variant="blue-secondary" onClick={props.onCancel}>
            {cancelText}
          </Button>
          <Button
            autoFocus
            variant={confirmType?.alert ? "red-primary" : "blue-primary"}
            onClick={props.onConfirm}
            disabled={confirmDisabled}
          >
            {confirmText}
          </Button>
        </FormThemeProvider>
      </ModalActions>
    </BaseModal>
  );
}

const ModalContentWrap = styled.div`
  color: var(--Text-T01, #333);
  font-family: var(--font-family-body, Inter);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  margin-top: 8px;
`;
